var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{class:_vm.$style.wrapper,attrs:{"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function({
    invalid
  }){return [_c('AdministratorSidebarController',_vm._g(_vm._b({attrs:{"invalid":invalid}},'AdministratorSidebarController',_vm.$attrs,false),_vm.$listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }